<div
  class="ddc-read-figure-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with note title and privacy -->
  <div class="sheet-header">
    <div class="header-left">
      <ddc-text-gradient class="text-xl" [_icon]="'hub'" [_text]="'Figure'" [_type]="'1'"></ddc-text-gradient>

      <ddc-privacy [code]="figure()?.privacy" [withText]="false"></ddc-privacy>
      <!-- Dictionaries row -->
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Content section -->
  <div class="sheet-content">
    <!-- Note details row -->
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + figure()?.owner?.username"
      [followerCount]="figure()?.owner?.followers_count"
      [minimal]="true"
      [subscription]="figure()?.owner?.subscription"
      [username]="figure()?.owner?.username"
      [userProfilePic]="figure()?.owner?.profile_pic"
      (click)="onProfilePicClick()"
    ></ddc-profile-pic>

    <div class="content-row figure-details">
      <span class="figure-text">{{ figure()?.title }}</span>
    </div>

    <!-- Description section -->
    <div class="content-row" *ngIf="figure()?.description">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <span>Description</span>
      </div>
      <div class="section-content markdown-body">
        <markdown [data]="figure()?.description"></markdown>
      </div>
    </div>

    <!-- Figure image -->
    <div class="content-row figure-image-row" *ngIf="figure()?.figure_pic">
      <img
        class="figure-image"
        [alt]="figure()?.title"
        [src]="getFigurePicUrl(figure()?.figure_pic)"
        (click)="_showLightbox = true"
      />
    </div>
  </div>
</div>

<!-- Lightbox overlay -->
<div class="figure-lightbox" *ngIf="_showLightbox" (click)="_showLightbox = false">
  <button class="lightbox-close" (click)="_showLightbox = false">
    <mat-icon>close</mat-icon>
  </button>
  <img
    class="lightbox-image"
    [alt]="figure()?.title"
    [src]="getFigurePicUrl(figure()?.figure_pic)"
    (click)="$event.stopPropagation()"
  />
</div>
